import React from "react";
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import OurTablesVsOthers from "./OurTablesVsOthers";
import WarrantyVehicleTable from "./WarrantyVehicleTable";
import WarrantyBoatTable from "./WarrantyBoatTable";
import WarrantyMotorsportsTable from "./WarrantyMotorsportsTable";
import WarrantyPatioTable from "./WarrantyPatioTable";
import CarComparisonTable from "./CarComparisonTable";

const tableComponents = {
    ourTablesVsOthers: OurTablesVsOthers,
    warrantyVehicleTable: WarrantyVehicleTable,
    warrantyBoatTable: WarrantyBoatTable,
    warrantyMotorsportsTable: WarrantyMotorsportsTable,
    warrantyPatioTable: WarrantyPatioTable,
    carComparisonTable: CarComparisonTable,
};

const TablesBlock = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const selectedTable = data?.table || "ourTablesVsOthers";
    const SelectedTableComponent = tableComponents[selectedTable];

    if (!SelectedTableComponent) {
        return null;
    }

    return (
        <div className={`tables-block ${classes.join(" ")}`}>
            <SelectedTableComponent />
        </div>
    );
};

export default TablesBlock;

